import { ChangeEvent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Row, Form, Card } from "react-bootstrap";
import Autocomplete from "../../common/Autocomplete";
import DateRange from "../../common/DateRange";
import { AvailableRole } from "../types/AvailableRole";

const preventSpaceIfFirst = (event: { target: { value: any; }; key: string; preventDefault: () => void; }) => {
  const value = event.target.value;
  
  if (!value && event.key === ' ') {
    event.preventDefault();
  }
};

const AddMemberItem = ({
  roles,
  member,
  add,
  setChanged,
  isLast,
}: {
  roles: AvailableRole[];
  member: any;
  add: Function;
  setChanged: Function;
  isLast: boolean;
}) => {
  return (
    <Card className="mb-5">
      <Card.Body>
        <Row className="mb-3">
          <Autocomplete
            className="col-4"
            id="volunteer-role-list"
            options={roles}
            filterKey={"RoleDescription"}
            label="Select a Role"
            selected={[member?.role || ""]}
            placeholder="Search list of roles ..."
            onChange={([value]: AvailableRole[]) =>
              value?.RoleDescription &&
              setChanged({ ...member, role: value.RoleDescription })
            }
          />
          <DateRange
            className="col"
            startLabel="Role Start Date"
            minDate={new Date()}
            onStartDateChange={(val: Date) =>
              setChanged({
                ...member,
                roleStartDate: val || null,
                role: member?.role || "",
              })
            }
            startDate={member?.roleStartDate || null}
            endLabel="Role End Date"
            onEndDateChange={(val: Date) =>
              setChanged({
                ...member,
                roleEndDate: val || null,
                role: member?.role || "",
              })
            }
            endDate={member?.roleEndDate || null}
          />

        </Row>
        <Row className="mb-3">
          <Form.Group className="col">
            <Form.Label>Name</Form.Label>
            <Form.Control
              onKeyDown={preventSpaceIfFirst}
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                setChanged({ ...member, full_name: event.target.value })
              }
              placeholder="Volunteer's Full Name"
              type="text"
              required
            />
            <Form.Control.Feedback type="invalid">
              Name is required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="col">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              onKeyDown={preventSpaceIfFirst}
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                setChanged({ ...member, email: event.target.value })
              }
              type="email"
              placeholder="Volunteer's email"
              required
            />
            <Form.Control.Feedback type="invalid">
              Email is required. Please ensure it follows the format: johndoe@example.com
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="col">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              onKeyDown={preventSpaceIfFirst}
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                setChanged({ ...member, phone: event.target.value })
              }
              type="tel"
              placeholder="Volunteer's phone number"
              maxLength={10}
              minLength={10}
              required
            />
            <Form.Control.Feedback type="invalid">
              10 digit phone number required
            </Form.Control.Feedback>
          </Form.Group>
        </Row>
        <Row>
          <Form.Group className="col-4">
            <Form.Label>Street Address</Form.Label>
            <Form.Control
              onKeyDown={preventSpaceIfFirst}
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                setChanged({ ...member, street_address: event.target.value })
              }
              placeholder="Street Address"
              type="text"
              required
            />
            <Form.Control.Feedback type="invalid">
              Street Address is required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="col-3">
            <Form.Label>City</Form.Label>
            <Form.Control
              onKeyDown={preventSpaceIfFirst}
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                setChanged({ ...member, city: event.target.value })
              }
              placeholder="City"
              type="text"
              required
            />
            <Form.Control.Feedback type="invalid">
              City is required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="col">
            <Form.Label>State</Form.Label>
            <Form.Control
              onKeyDown={preventSpaceIfFirst}
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                setChanged({ ...member, state: event.target.value })
              }
              placeholder="State"
              type="text"
              required
            />
            <Form.Control.Feedback type="invalid">
              State is required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="col">
            <Form.Label>Zip</Form.Label>
            <Form.Control
              onKeyDown={preventSpaceIfFirst}
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                setChanged({ ...member, zip: event.target.value })
              }
              placeholder="Zip Code"
              type="text"
              maxLength={5}
              minLength={5}
              required
            />
            <Form.Control.Feedback type="invalid">
              5 digit ZIP Code is required.
            </Form.Control.Feedback>
          </Form.Group>
          <div className="col-2 d-flex align-items-end justify-content-end">
            {isLast && (
              <Button
                variant="secondary"
                className="mr-2"
                onClick={() => add()}
              >
                Add Another <FontAwesomeIcon icon="plus" />
              </Button>
            )}
          </div>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default AddMemberItem;
